export enum RuleStatusEnum {
    PUBLIC = 'public',
    ACTIVE = 'active',
    INACTIVE = 'inactive',
    DELETED = 'deleted',
    DRAFT = 'draft'
}